import { render } from "./NicsTab.vue?vue&type=template&id=148e16a8&scoped=true"
import script from "./NicsTab.vue?vue&type=script&lang=js"
export * from "./NicsTab.vue?vue&type=script&lang=js"

import "./NicsTab.vue?vue&type=style&index=0&id=148e16a8&scoped=true&lang=css"

import exportComponent from "/builds/cloudstack/keycloak-auth/.cloudstack-src/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148e16a8"]])

export default __exports__